var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "clock",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.167,14.333a7.167,7.167,0,1,1,7.167-7.167A7.173,7.173,0,0,1,7.167,14.333ZM7.167,1a6.167,6.167,0,1,0,6.167,6.167A6.174,6.174,0,0,0,7.167,1Z",
    transform: "translate(0.833 0.833)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M3.213,6.113A.446.446,0,0,1,2.96,6.04L.893,4.807A1.966,1.966,0,0,1,0,3.233V.5A.5.5,0,0,1,.5,0,.5.5,0,0,1,1,.5V3.233a.985.985,0,0,0,.407.713L3.473,5.18a.5.5,0,0,1,.173.687A.514.514,0,0,1,3.213,6.113Z",
    transform: "translate(7.26 4.507)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H16V16H0Z",
    fill: "none",
    opacity: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.739f69df0f997fe7ab2649109edb95a9.svg";
export { ForwardRef as ReactComponent };